/*=========================================================================================
  File Name: moduleMapState.js
  Description: Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
	filter_exact_values: false,
	language: "es",
	notifications_days: 1,
	notifications_number: 100,
	remove_old_notifications: false,
	company_config_list: [],
};
